import IntegrationTypes from 'Enums/Integration/IntegrationTypes';

export default {
  [IntegrationTypes.MERCADO_LIVRE]: 'mercado-livre',
  [IntegrationTypes.MAGAZINE_LUIZA]: 'magazine-luiza',
};
